<template>
  <div class="cadfm-container-horizontal">
    <!-- <Left v-show="isVisibleLeft&&!isPlugin" :lang="lang.Left"></Left> -->
    <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
    <Middle  :lang="lang.Middle"></Middle>
    <!--<Right></Right>-->
 </div>
</template>

<script>
import Left from '@/components/PartManager/Views/PartDerive/Left/Left'
import Middle from '@/components/PartManager/Views/PartDerive/Middle/Middle'
//import Right from '@/components/PartManager/Views/PartDerive/Right/Right'
import { mapGetters } from 'vuex'


export default {
  name: 'PartDerive',
  components:{
    Left,
    Middle,
    //Right
  },
  props:{
    routingData: Object,
    lang: Object
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),
  
  },
  
}

</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartDerive.vue